// src/client/components/projects/ProjectDetailStatCards.tsx
interface Props {
  memberCount: number;
  createdAt: string;
}

export function ProjectDetailStatCards({ memberCount, createdAt }: Props) {
  const created = new Date(createdAt).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="rounded-lg border bg-card p-4">
        <p className="text-xs text-muted-foreground">Team members</p>
        <p className="mt-1 text-2xl font-semibold tabular-nums">{memberCount}</p>
      </div>
      <div className="rounded-lg border bg-card p-4">
        <p className="text-xs text-muted-foreground">Created</p>
        <p className="mt-1 text-2xl font-semibold">{created}</p>
      </div>
    </div>
  );
}
